import React from 'react';
import {
  useResponsiveValue,
  Tooltip,
  SidebarPriorityItem,
  SIDEBAR_BREAKPOINTS,
} from '@monash/portal-react';
import UserInitialsIcon from './UserInitialsIcon';
import c from './userInitials.module.scss';

export const USER_INITIALS_TRIGGER_ID = 'user-initials-trigger';

const UserInitialsTrigger = ({
  triggerRef,
  title = 'User menu',
  isInSidebar = false,
  avatarSrc,
  ...restProps
}) => {
  const size = useResponsiveValue(SIDEBAR_BREAKPOINTS);
  const isMobile = ['XS', 'S'].includes(size);

  return isInSidebar ? (
    <SidebarPriorityItem
      className={c.triggerInSidebar}
      aria-label={title}
      aria-haspopup={isMobile ? 'dialog' : 'menu'}
      buttonRef={triggerRef}
      id={USER_INITIALS_TRIGGER_ID}
      icon={<UserInitialsIcon avatarSrc={avatarSrc} />}
      {...restProps}
    >
      {title}
    </SidebarPriorityItem>
  ) : (
    <Tooltip title={title}>
      <button
        type="button"
        className={c.trigger}
        aria-label={title}
        aria-haspopup={isMobile ? 'dialog' : 'menu'}
        ref={triggerRef}
        id={USER_INITIALS_TRIGGER_ID}
        {...restProps}
      >
        <UserInitialsIcon avatarSrc={avatarSrc} />
      </button>
    </Tooltip>
  );
};

export default UserInitialsTrigger;
